// extracted by mini-css-extract-plugin
export default {"root":"ItemListCell_root__LlbZ+","subtext":"ItemListCell_subtext__3GiiK"};